import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionHubWarning from '../../common/SubscriptionHubWarning';
import withRouter from '../../../withRouter';

/**
 * Composant pour le tunnel de redirection vers le portail PER (MMA ou Cardif)
 * Utilise le composant générique SubscriptionHubWarning
 */
const PerHub = ({ location, params, navigate }) => {
    const { contractType } = params;

    // Détermination de la clé de configuration selon le type de contrat
    const hubConfigKey = contractType.toLowerCase().includes('mma') ? 'PER_MMA' : 'PER_CARDIF';

    return (
        <SubscriptionHubWarning
            hubConfigKey={hubConfigKey}
            location={location}
            params={params}
            navigate={navigate}
        />
    );
};

PerHub.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        contractId: PropTypes.string,
        contractType: PropTypes.string,
    }),
    navigate: PropTypes.shape({}),
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
};

export default withRouter(PerHub);
